import { Route } from '@angular/router';

import { OmniCloudAuthComponent } from './omni-cloud-auth/omni-cloud-auth.component';
export const AUTHENTICATION_ROUTES: Array<Route> = [
    {
        path: 'login',
        component: OmniCloudAuthComponent
    }
];